<template>
  <van-form ref="FindPwdForm" :model="FindPwdForm" id="findpwd-form" @submit="onSubmit('FindPwdForm')">
    <van-field label="手机号" :value="FindPwdForm.mobile" readonly />
    <van-field
      v-model="FindPwdForm.captcha"
      center
      clearable
      label="验证码"
      placeholder="请输入验证码"
      :rules="[{ required: true, message: '验证码不能为空' }]"
    >
      <template #button>
        <img :src="captchaUrl" @click="changeCaptcha" height="28" width="100" style="margin-left: 10px; display: block;" />
      </template>
    </van-field>
    <van-field
      v-model="FindPwdForm.msgcode"
      type="number"
      center
      clearable
      label="短信验证码"
      placeholder="请输入短信验证码"
      :rules="[{ required: true, message: '短信验证码不能为空' }]"
    >
      <template #button>
        <van-button native-type="button" size="small" type="primary" class="getmsgcode" :disabled="!getMsgButtonState" @click="getMsgCode" :style="getMsgButtonWidth">
          发送验证码
          <span v-if="!getMsgButtonState">({{ timer }})</span>
        </van-button>
      </template>
    </van-field>
    <van-button round block type="primary" native-type="submit" :disabled="isDisable" style="margin-top: 15px;">
      下一步
    </van-button>
  </van-form>
</template>
<script>
export default {
  name: 'FindpwdVerify',
  data () {
    return {
      FindPwdForm: {
        captcha: '',
        msgcode: '',
        uid: '',
        mobile: ''
      },
      isDisable: false,
      rules: {
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        msgcode: [
          { required: true, message: '请输入手机短信验证码', trigger: 'blur' }
        ]
      },
      captchaUrl: this.$api.global.getCaptchaUrl(),
      getMsgButtonState: true,
      timer: 60
    }
  },
  mounted: function () {
    const reg = /^1[3456789]\d{9}$/
    if (this.$route.query.mobile === '' || !reg.test(this.$route.query.mobile) || this.$route.query.uid === '') {
      this.$router.replace({ name: 'FindPwd' })
    }
    this.FindPwdForm.mobile = this.$route.query.mobile
    this.FindPwdForm.uid = this.$route.query.uid
    this.$nextTick(() => {
      this.changeStep()
    })
  },
  methods: {
    changeStep () {
      this.$root.$emit('changeCurrentStep', 1)
    },
    changeCaptcha () {
      this.captchaUrl = this.$api.global.getCaptchaUrl()
    },
    getMsgCode () {
      if (this.FindPwdForm.captcha === '') {
        this.$notify('请先填写验证码！')
      } else {
        this.$api.global.getMsgCode(this.FindPwdForm.mobile, this.FindPwdForm.captcha, 'findpwd')
          .then((res) => {
            if (res.data.code === 200) {
              this.$toast.success('获取短信验证码成功！')
              this.getMsgButtonState = false
            } else {
              this.$notify(res.data.message)
              this.changeCaptcha()
            }
          })
        var data = this
        var counter = setInterval(function () {
          data.timer--
          if (data.timer === 0) {
            data.timer = 60
            data.getMsgButtonState = true
            clearInterval(counter)
          }
        }, 1000)
      }
    },
    onSubmit (formName) {
      this.isDisable = true
      this.$api.user.findpwdVerify(this.FindPwdForm)
        .then((res) => {
          if (res.data.code === 200) {
            this.$router.replace({ name: 'FindPwdReset', query: this.FindPwdForm })
          } else {
            this.$notify(res.data.message)
            this.isDisable = false
          }
        })
        .catch(() => {
          this.isDisable = false
        })
    }
  },
  computed: {
    getMsgButtonWidth: function () {
      return this.getMsgButtonState === false ? 'width:170px' : 'width:145px'
    }
  }
}
</script>